var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 373",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4882_25446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 327.45H0V327.7H500V327.45Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5809 336.97H52.4609V337.22H85.5809V336.97Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.001 337.09H171.141V337.34H225.001V337.09Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.96 342.13H105.77V342.38H124.96V342.13Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 342.01H426.77V342.26H446V342.01Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.86 342.01H387.57V342.26H417.86V342.01Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.89 340.35H328.33V340.6H370.89V340.35Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.009 282.85H43.9092C40.7592 282.85 38.1992 280.29 38.1992 277.14V5.71C38.1992 2.56 40.7592 0 43.9092 0H237.009C240.159 0 242.719 2.56 242.719 5.71V277.14C242.719 280.29 240.159 282.85 237.009 282.85ZM43.9092 0.25C40.8992 0.25 38.4492 2.7 38.4492 5.71V277.14C38.4492 280.15 40.8992 282.6 43.9092 282.6H237.009C240.019 282.6 242.469 280.15 242.469 277.14V5.71C242.469 2.7 240.019 0.25 237.009 0.25H43.9092Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31 282.85H260.21C257.06 282.85 254.5 280.29 254.5 277.14V5.71C254.5 2.56 257.06 0 260.21 0H453.31C456.46 0 459.02 2.56 459.02 5.71V277.14C459.02 280.29 456.46 282.85 453.31 282.85ZM260.21 0.25C257.2 0.25 254.75 2.7 254.75 5.71V277.14C254.75 280.15 257.2 282.6 260.21 282.6H453.31C456.32 282.6 458.77 280.15 458.77 277.14V5.71C458.77 2.7 456.32 0.25 453.31 0.25H260.21Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.879 36.0699H303.779V174.69H419.879V36.0699Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78 36.0699H306.68V174.69H422.78V36.0699Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.58 168.84V41.9099L311.89 41.9099V168.84H417.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.58 168.84V41.9099H415.39V168.84H417.58Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.62 138.77H308.83V146.62H420.62V138.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.449 26.3999H298.109C297.669 26.3999 297.309 26.7599 297.309 27.1999C297.309 27.6399 297.669 27.9999 298.109 27.9999H428.449C428.889 27.9999 429.249 27.6399 429.249 27.1999C429.249 26.7599 428.889 26.3999 428.449 26.3999Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.248 31.2C431.457 31.2 433.248 29.4091 433.248 27.2C433.248 24.9908 431.457 23.2 429.248 23.2C427.039 23.2 425.248 24.9908 425.248 27.2C425.248 29.4091 427.039 31.2 429.248 31.2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.859 31.68C304.269 31.68 303.779 31.19 303.779 30.6V28.28C303.779 27.69 304.269 27.2 304.859 27.2C305.449 27.2 305.939 27.69 305.939 28.28V30.6C305.939 31.19 305.449 31.68 304.859 31.68Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.369 31.68C415.779 31.68 415.289 31.19 415.289 30.6V28.28C415.289 27.69 415.779 27.2 416.369 27.2C416.959 27.2 417.449 27.69 417.449 28.28V30.6C417.449 31.19 416.959 31.68 416.369 31.68Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M428.188 27.2H308.828V85.4199H428.188V27.2Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.738 31.2C319.947 31.2 321.738 29.4091 321.738 27.2C321.738 24.9908 319.947 23.2 317.738 23.2C315.529 23.2 313.738 24.9908 313.738 27.2C313.738 29.4091 315.529 31.2 317.738 31.2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7094 189.58H47.3594L51.1094 140.01H85.9594L89.7094 189.58Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4196 189.58H73.1396L71.5996 140.01H78.3096L80.4196 189.58Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6599 189.58H66.4199V327.45H70.6599V189.58Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1391 209.88H66.9391C65.3817 209.88 64.1191 211.143 64.1191 212.7V223.11C64.1191 224.667 65.3817 225.93 66.9391 225.93H70.1391C71.6966 225.93 72.9591 224.667 72.9591 223.11V212.7C72.9591 211.143 71.6966 209.88 70.1391 209.88Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1391 235.6H66.9391C65.3817 235.6 64.1191 236.863 64.1191 238.42V248.83C64.1191 250.387 65.3817 251.65 66.9391 251.65H70.1391C71.6966 251.65 72.9591 250.387 72.9591 248.83V238.42C72.9591 236.863 71.6966 235.6 70.1391 235.6Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2401 327.45H61.8301C61.8301 325.87 63.1101 324.59 64.6901 324.59H72.3901C73.9701 324.59 75.2501 325.87 75.2501 327.45H75.2401Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6599 189.58H66.4199V192.17H70.6599V189.58Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3096 148.45L213.35 148.45L213.35 31.09L96.3096 31.09L96.3096 148.45Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3091 31.09H94.2891V148.45H96.3091V31.09Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.65 141.04H203.02V38.5099L106.65 38.5099L106.65 141.04Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29 118.32H160.39C172.143 118.32 181.67 108.793 181.67 97.0399V82.5099C181.67 70.7573 172.143 61.2299 160.39 61.2299L149.29 61.2299C137.537 61.2299 128.01 70.7573 128.01 82.5099V97.0399C128.01 108.793 137.537 118.32 149.29 118.32Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.519 192.49H362.969V327.44H407.519V192.49Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.769 327.45H407.519V308.82H362.969L385.769 327.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.849 192.49H185.299V327.44H229.849V192.49Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.509 192.49H210.869V321.03H407.509V192.49Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.619 327.45H210.869V308.82H255.419L232.619 327.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.648 240.39H227.748V272.56H390.648V240.39Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.648 279.43H227.748V311.6H390.648V279.43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.849 243.83H266.539C263.099 243.83 260.309 241.04 260.309 237.6H358.069C358.069 241.04 355.279 243.83 351.839 243.83H351.849Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.648 201.35H227.748V233.52H390.648V201.35Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.849 204.79H266.539C263.099 204.79 260.309 202 260.309 198.56H358.069C358.069 202 355.279 204.79 351.839 204.79H351.849Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.849 282.87H266.539C263.099 282.87 260.309 280.08 260.309 276.64H358.069C358.069 280.08 355.279 282.87 351.839 282.87H351.849Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.999 372.61C357.082 372.61 443.889 367.542 443.889 361.29C443.889 355.038 357.082 349.97 249.999 349.97C142.917 349.97 56.1094 355.038 56.1094 361.29C56.1094 367.542 142.917 372.61 249.999 372.61Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5491 162.54H208.379H224.789C215.729 162.54 207.939 155.19 207.409 146.13L204.779 101.65H55.5391L58.1691 146.14C58.7091 155.21 66.4891 162.55 75.5491 162.55V162.54Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.5491 162.54H208.379H224.789C215.729 162.54 207.939 155.19 207.409 146.13L204.779 101.65H55.5391L58.1691 146.14C58.7091 155.21 66.4891 162.55 75.5491 162.55V162.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.849 72.08H103.019C93.9488 72.08 87.0488 79.42 87.5788 88.49L90.9888 146.12C91.5288 155.18 84.6088 162.53 75.5488 162.53H91.9588H224.789C233.849 162.53 240.759 155.19 240.229 146.12L240.599 152.36L236.819 88.49C236.279 79.43 243.199 72.08 252.259 72.08H235.849Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26 72.09H119.43H103.02C112.08 72.09 119.87 79.44 120.4 88.5L133.22 305.16H282.46L269.64 88.5C269.1 79.43 261.32 72.09 252.26 72.09Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M252.26 72.09H119.43H103.02C112.08 72.09 119.87 79.44 120.4 88.5L133.22 305.16H282.46L269.64 88.5C269.1 79.43 261.32 72.09 252.26 72.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.658 133.72H142.968L141.328 106.03H169.018L170.658 133.72ZM146.038 130.47H167.208L165.958 109.3H144.788L146.038 130.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.519 198.83H146.829L145.189 171.14H172.879L174.519 198.83ZM149.889 195.58H171.059L169.809 174.41H148.639L149.889 195.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.369 263.94H150.679L149.039 236.26H176.729L178.369 263.94ZM153.749 260.69H174.919L173.669 239.52H152.499L153.749 260.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.84 106.04H184.18V109.3H247.84V106.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.078 118.25H184.898V121.51H241.078V118.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.279 130.47H185.619V133.73H249.279V130.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.689 171.15H188.029V174.41H251.689V171.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.12 183.36H188.75V186.62H226.12V183.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.769 195.58H189.479V198.84H208.769V195.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.139 195.58H221.309V198.84H253.139V195.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.539 236.26H191.879V239.52H255.539V236.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.269 248.47H192.609V251.73H256.269V248.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.538 260.69H193.328V263.95H228.538V260.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.628 127.21C157.938 127.21 157.268 126.95 156.768 126.47L149.968 120.05C148.878 119.02 148.828 117.3 149.858 116.22C150.888 115.13 152.608 115.08 153.688 116.11L158.518 120.66L169.368 109.13C170.388 108.04 172.108 107.99 173.208 109.01C174.298 110.04 174.348 111.75 173.328 112.84L160.618 126.35C160.128 126.87 159.448 127.18 158.718 127.2C158.688 127.2 158.668 127.2 158.638 127.2L158.628 127.21Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49 192.32C161.8 192.32 161.13 192.06 160.63 191.58L153.83 185.16C152.74 184.13 152.69 182.41 153.72 181.32C154.75 180.23 156.47 180.18 157.56 181.21L162.39 185.76L173.24 174.23C174.26 173.14 175.98 173.09 177.08 174.11C178.17 175.14 178.22 176.85 177.2 177.94L164.49 191.45C164 191.97 163.32 192.28 162.59 192.3C162.56 192.3 162.54 192.3 162.51 192.3L162.49 192.32Z",
    fill: "#675AC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.339 257.43C165.649 257.43 164.979 257.17 164.479 256.69L157.679 250.27C156.589 249.24 156.539 247.52 157.569 246.43C158.599 245.34 160.319 245.29 161.399 246.32L166.229 250.87L177.079 239.34C178.099 238.25 179.819 238.2 180.909 239.22C181.999 240.25 182.049 241.96 181.029 243.05L168.319 256.56C167.829 257.08 167.149 257.39 166.419 257.41C166.389 257.41 166.369 257.41 166.339 257.41V257.43Z",
    fill: "#675AC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4882_25446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 372.61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncSuccess);
export default __webpack_public_path__ + "static/media/sync-success.305096eccd544c4052fcc2095c071c06.svg";
export { ForwardRef as ReactComponent };